<template>
  <div id="container">
    <div style="display: flex">
      <div>
        <el-button @click="save" type="success">保存坐标</el-button>
        <el-button @click="deletePoint" type="warning">删除点</el-button>
      </div>
      <el-form
          ref="form"
          :model="form"
          label-width="100px"
          style="padding-bottom: 0px; float: left; margin-right: 10px"
          @submit.native.prevent
      >
        <el-form-item label="详细地址：" prop="address">
          <el-input v-model="form.address" placeholder="请输入详细地址并选择" class="input" @blur="handleBlur"></el-input>
          <el-button @click="handleBlur" style="margin-left: 15px;" type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div id="map" style="width: 100%; height: 58vh"></div>
  </div>
</template>

<script>
// 天地图配置
const TIANDITU_CONFIG = {
  tk: 'e4d924258c1084ed7cde9c76fed4d520',
}

import config from "../../config/index";

export default {
  props: ["marker", "type", "areas", "contentList", "markerName", "allList", "visible"],
  name: "MapComponent",
  data() {
    return {
      form: {
        address: '', // 详细地址
        addrPoint: {
          lng: 0,
          lat: 0,
        },
      },
      geocoder: null,
      map: null,
      editor: undefined,
      centerPoint: null,
      centerArea: null,
      openEdit: false,
      polygons: null,
      activeTypeEdit: false,
      mk: null,
      isMapInitialized: false,
      // 记录初始传入的坐标，用于判断是否需要更新
      initialMarker: null,
      // 添加一个标志位，标记是否已经重置
      isReset: false,
      // 标记是否第一次加载完成
      isFirstLoad: true,
      // 缓存父组件传入的 marker
      cachedMarker: null,
      // 记录当前有效的点位数据
      currentPointData: null,
      // 防止重复处理
      isBlurHandling: false,
    };
  },
  beforeDestroy() {
    this.destroyMap();
  },
  mounted() {
    // 判断是否为新增模式，如果是则重置所有数据
    if (this.type === 'add') {
      this.resetAllData();
    }
    this.loadTiandituAPI();
  },
  // 监听 visible 属性（父组件控制显示/隐藏）
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          console.log('组件显示，当前模式：', this.type);
          
          // 移除新增模式的强制清空逻辑，避免时序问题
          // 改为：无论什么模式，都重新加载数据，但不清空缓存
          if (this.map && this.isMapInitialized) {
            // 先清空现有标记，但不清空数据缓存
            if (this.mk) {
              this.map.removeOverLay(this.mk);
              this.mk = null;
            }
            this.reloadMapData();
          } else {
            this.loadTiandituAPI();
          }
        }
      },
      immediate: true
    },
    // 监听 marker 变化，当父组件传入新坐标时更新
    marker: {
      handler(newVal, oldVal) {
        // 缓存最新的 marker
        this.cachedMarker = newVal;
        // 如果是添加模式，不显示已有坐标
        if (this.type === 'add') {
          console.log('新增模式，忽略 marker 变化');
          return;
        }
        // 只有当新值和旧值不同，且地图已初始化时才更新
        if (newVal && newVal !== oldVal && this.map && this.isMapInitialized) {
          console.log('marker 变化，更新地图点位:', newVal);
          // 清空当前点位
          this.deletePoint();
          // 清空地址
          this.form.address = '';
          // 重新设置点位
          this.$nextTick(() => {
            this.updatePointFromProps();
          });
        }
      },
      deep: true,
      immediate: true
    },
    // 监听 type 变化
    type: {
      handler(newVal) {
        console.log('type 变化：', newVal);
        if (newVal === 'add' && this.map && this.isMapInitialized) {
          console.log('新增模式，清空地图数据');
          this.forceResetData();
          // 重置地图中心到默认位置
          const defaultPoint = new T.LngLat(config.point.lng, config.point.lat);
          this.map.centerAndZoom(defaultPoint, config.mapAttr.zoom);
        } else if (newVal === 'edit' && this.map && this.isMapInitialized && this.marker) {
          console.log('编辑模式，更新点位');
          this.updatePointFromProps();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 强制重置所有数据（用于新增模式）
    forceResetData() {
      console.log('强制重置所有数据');
      this.isReset = true;
      
      // 清空当前点位数据缓存
      this.currentPointData = null;
      
      // 清空地址输入框
      this.form.address = '';
      this.form.addrPoint = { lng: 0, lat: 0 };
      
      // 清除标记点
      if (this.mk) {
        try {
          if (this.map) {
            this.map.removeOverLay(this.mk);
          }
        } catch(e) {
          console.error('移除标记失败:', e);
        }
        this.mk = null;
      }
      
      // 清除 centerPoint
      this.centerPoint = null;
      
      // 清空初始标记
      this.initialMarker = null;
      
      // 清空地图上的所有覆盖物
      if (this.map && this.map.clearOverLays) {
        try {
          this.map.clearOverLays();
        } catch(e) {
          console.error('清空覆盖物失败:', e);
        }
      }
      
      // 重置重置标志
      setTimeout(() => {
        this.isReset = false;
      }, 300);
    },
    
    // 重置所有数据
    resetAllData() {
      console.log('重置所有数据');
      // 设置重置标志
      this.isReset = true;
      
      // 清空当前点位数据缓存
      this.currentPointData = null;
      
      // 清空点位相关数据
      if (this.centerPoint) {
        if (this.centerPoint.setMap) {
          this.centerPoint.setMap(null);
        }
        this.centerPoint = null;
      }
      
      // 清空地址输入框
      this.form.address = '';
      this.form.addrPoint = { lng: 0, lat: 0 };
      
      // 移除地图标记
      if (this.map && this.mk) {
        try {
          this.map.removeOverLay(this.mk);
        } catch(e) {
          console.error('移除标记失败:', e);
        }
        this.mk = null;
      }
      
      // 重置初始标记
      this.initialMarker = null;
      
      // 强制清空地图上的所有覆盖物
      if (this.map && this.map.clearOverLays) {
        try {
          this.map.clearOverLays();
        } catch(e) {
          console.error('清空覆盖物失败:', e);
        }
      }
      
      console.log('重置完成，当前状态 - centerPoint:', this.centerPoint, 'mk:', this.mk, 'currentPointData:', this.currentPointData);
    },
    
    // 重新加载地图数据
    reloadMapData() {
      if (!this.map) return;
      
      // 清空所有覆盖物
      if (this.map.clearOverLays) {
        this.map.clearOverLays();
      }
      
      // 重置标记
      this.mk = null;
      this.centerPoint = null;
      
      // 如果是编辑模式且有坐标，显示坐标
      if (this.type !== 'add' && this.marker && this.marker !== '[]' && this.marker !== 'null' && this.marker !== 'undefined') {
        console.log('编辑模式，加载坐标:', this.marker);
        // 延迟重置标志，然后更新点位
        setTimeout(() => {
          this.updatePointFromProps();
        }, 100);
      } else if (this.type === 'add') {
        // 新增模式才清空地址
        console.log('新增模式，清空地址并重置地图中心');
        this.form.address = '';
        this.currentPointData = null;
        const defaultPoint = new T.LngLat(config.point.lng, config.point.lat);
        this.map.centerAndZoom(defaultPoint, config.mapAttr.zoom);
      }
    },

    destroyMap() {
      if (this.map) {
        if (this.mk) {
          try {
            this.map.removeOverLay(this.mk);
          } catch(e) {}
          this.mk = null;
        }
        
        if (this.map.clearOverLays) {
          try {
            this.map.clearOverLays();
          } catch(e) {}
        }
        
        // 移除所有事件监听
        if (this.map.removeEventListener) {
          try {
            this.map.removeEventListener("click");
          } catch(e) {}
        }
        
        this.map = null;
      }
      
      // 清空DOM容器内容
      const mapContainer = document.getElementById("map");
      if (mapContainer) {
        const parent = mapContainer.parentNode;
        if (parent) {
          const newMapDiv = document.createElement('div');
          newMapDiv.id = "map";
          newMapDiv.style.width = "100%";
          newMapDiv.style.height = "58vh";
          newMapDiv.style.marginTop = "10px";
          newMapDiv.style.position = "absolute";
          parent.replaceChild(newMapDiv, mapContainer);
        }
      }
      
      this.isMapInitialized = false;
      this.centerPoint = null;
      this.currentPointData = null;
    },

    loadTiandituAPI() {
      // 先销毁旧地图
      if (this.map) {
        this.destroyMap();
      }
      
      // 重置表单数据 - 确保清空搜索框
      this.form.address = '';
      this.form.addrPoint = { lng: 0, lat: 0 };
      this.currentPointData = null;
      
      if (window.T && window.T.Map) {
        this.initMap();
        return;
      }

      if (document.querySelector('script[src*="api.tianditu.gov.cn"]')) {
        const checkInterval = setInterval(() => {
          if (window.T && window.T.Map) {
            clearInterval(checkInterval);
            this.initMap();
          }
        }, 100);
        return;
      }

      const script = document.createElement('script');
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_CONFIG.tk}`;
      script.onload = () => {
        console.log('天地图API加载成功');
        setTimeout(() => {
          this.initMap();
        }, 500);
      };
      script.onerror = () => {
        console.error('天地图API加载失败');
        this.$message.error('地图API加载失败，请检查网络或密钥');
      };
      document.head.appendChild(script);
    },

    async reverseGeocodingClick(lng, lat) {
      try {
        const postStr = JSON.stringify({
          lon: parseFloat(lng),
          lat: parseFloat(lat),
          ver: 1
        });
        
        const response = await fetch(`https://api.tianditu.gov.cn/geocoder?postStr=${encodeURIComponent(postStr)}&type=geocode&tk=${TIANDITU_CONFIG.tk}`);
        const data = await response.json();
        
        if (data.status === '0' && data.result) {
          this.form.address = data.result.formatted_address || data.result.address;
          // 更新当前点位数据缓存
          if (this.currentPointData) {
            this.currentPointData.address = this.form.address;
          }
        }
      } catch (error) {
        console.error('逆地理编码失败:', error);
      }
    },

    initMap() {
      let mapContainer = document.getElementById("map");
      if (!mapContainer) {
        console.error('地图容器不存在');
        return;
      }
      
      mapContainer.innerHTML = '';
      
      let that = this;
      this.map = new T.Map("map");
      
      // 检查是否需要显示传入的坐标
      let centerPoint;
      let hasValidMarker = false;
      
      // 更严格的坐标有效性检查
      const isValidCoordinate = (markerData) => {
        if (!markerData || markerData.length === 0) return false;
        const coord = markerData[0];
        if (!coord || typeof coord.lng === 'undefined' || typeof coord.lat === 'undefined') return false;
        // 检查是否是默认值
        if (coord.lng === config.point.lng && coord.lat === config.point.lat) return false;
        // 检查是否是零值
        if (coord.lng === 0 && coord.lat === 0) return false;
        return true;
      };
      
      // 只在非添加模式且有坐标时显示已有坐标
      if (this.type !== 'add' && this.marker && this.marker !== '[]' && this.marker !== 'null' && this.marker !== 'undefined') {
        try {
          const markerData = JSON.parse(this.marker);
          if (isValidCoordinate(markerData)) {
            centerPoint = new T.LngLat(markerData[0].lng, markerData[0].lat);
            hasValidMarker = true;
            this.initialMarker = markerData;
            // 缓存点位数据
            this.currentPointData = {
              lng: markerData[0].lng,
              lat: markerData[0].lat,
              address: this.markerName || ''
            };
            console.log('编辑模式 - 加载已有坐标：', centerPoint);
          } else {
            console.log('编辑模式 - 坐标无效或为默认值');
          }
        } catch (error) {
          console.error('解析marker失败:', error);
        }
      }
      
      // 如果没有有效坐标，使用默认中心点
      if (!centerPoint) {
        centerPoint = new T.LngLat(config.point.lng, config.point.lat);
      }
      
      this.map.centerAndZoom(centerPoint, config.mapAttr.zoom);
      this.map.enableScrollWheelZoom(true);
      
      if (this.map.clearOverLays) {
        this.map.clearOverLays();
      }
      
      // 只有在有有效坐标且不是添加模式，并且坐标不是默认值时，才添加标记
      if (hasValidMarker && this.type !== 'add') {
        this.mk = new T.Marker(centerPoint);
        this.map.addOverLay(this.mk);
        this.centerPoint = {
          geometries: [{
            position: { lat: centerPoint.getLat(), lng: centerPoint.getLng() }
          }],
          setMap: (val) => {
            if (val === null && this.mk) {
              this.map.removeOverLay(this.mk);
              this.mk = null;
            }
          }
        };
        
        // 如果有传入地址名称，使用传入的地址
        if (this.markerName && this.markerName !== '') {
          this.form.address = this.markerName;
          if (this.currentPointData) {
            this.currentPointData.address = this.markerName;
          }
        } else {
          // 否则通过逆地理编码获取地址
          this.reverseGeocodingClick(centerPoint.getLng(), centerPoint.getLat());
        }
      } else {
        // 添加模式或没有坐标时，清空地址输入框
        this.form.address = '';
        // 确保没有标记点
        this.mk = null;
        this.centerPoint = null;
        this.currentPointData = null;
      }
      
      this.map.addEventListener("click", (evt) => {
        var lnglat = evt.lnglat;
        var lng = lnglat.getLng().toFixed(6);
        var lat = lnglat.getLat().toFixed(6);
        that.reverseGeocodingClick(lng, lat);
        that.addPoint(lat, lng);
      });
      
      this.isMapInitialized = true;
      this.isFirstLoad = false;
      
      // 地图初始化完成后，清除重置标志
      setTimeout(() => {
        this.isReset = false;
      }, 200);
    },

    // 从 props 更新点位
    updatePointFromProps() {
      if (!this.map || !this.marker) return;
      
      // 如果是添加模式，不显示已有坐标
      if (this.type === 'add') {
        console.log('新增模式，不显示坐标');
        this.form.address = '';
        return;
      }
      
      try {
        const markerData = JSON.parse(this.marker);
        if (markerData && markerData.length > 0 && markerData[0] && markerData[0].lng && markerData[0].lat) {
          // 检查坐标是否有效
          if (markerData[0].lng === config.point.lng && markerData[0].lat === config.point.lat && !this.mk) {
            console.log('这是默认坐标，不显示点位');
            return;
          }
          
          const point = new T.LngLat(markerData[0].lng, markerData[0].lat);
          this.map.panTo(point);
          
          if (this.mk) {
            this.map.removeOverLay(this.mk);
          }
          
          this.mk = new T.Marker(point);
          this.map.addOverLay(this.mk);
          
          this.centerPoint = {
            geometries: [{
              position: { lat: markerData[0].lat, lng: markerData[0].lng }
            }],
            setMap: (val) => {
              if (val === null && this.mk) {
                this.map.removeOverLay(this.mk);
                this.mk = null;
              }
            }
          };
          
          // 缓存点位数据
          this.currentPointData = {
            lng: markerData[0].lng,
            lat: markerData[0].lat,
            address: this.markerName || ''
          };
          
          if (this.markerName && this.markerName !== '') {
            this.form.address = this.markerName;
          } else {
            this.reverseGeocodingClick(markerData[0].lng, markerData[0].lat);
          }
          
          console.log('更新点位成功:', this.currentPointData);
        } else {
          // 没有有效坐标时清空地址
          this.form.address = '';
          this.currentPointData = null;
        }
      } catch (error) {
        console.error('更新点位失败:', error);
        this.form.address = '';
        this.currentPointData = null;
      }
    },

    // pointData 方法 - 供父组件调用
    pointData() {
      // 获取当前地图上的点位信息
      console.log('pointData 方法被调用');
      console.log('当前状态 - isReset:', this.isReset);
      console.log('isMapInitialized:', this.isMapInitialized);
      console.log('currentPointData:', this.currentPointData);
      console.log('type:', this.type);
      
      // 如果正在重置中或地图未初始化，返回 null
      if (this.isReset) {
        console.log('正在重置数据，返回 null');
        return null;
      }
      
      if (!this.isMapInitialized) {
        console.log('地图未初始化，返回 null');
        return null;
      }
      
      // 优先返回缓存的数据
      if (this.currentPointData && this.currentPointData.lng && this.currentPointData.lat) {
        // 检查是否是默认坐标
        if (this.currentPointData.lng !== config.point.lng || this.currentPointData.lat !== config.point.lat) {
          console.log('从缓存返回点位数据:', this.currentPointData);
          return { ...this.currentPointData };
        }
      }
      
      // 检查是否有有效的点位数据
      let hasValidPoint = false;
      let pointInfo = null;
      
      if (this.centerPoint && this.centerPoint.geometries && this.centerPoint.geometries.length > 0) {
        try {
          const position = this.centerPoint.geometries[0].position;
          if (position && position.lng && position.lat && position.lng !== 0 && position.lat !== 0) {
            // 检查是否是默认坐标
            if (position.lng !== config.point.lng || position.lat !== config.point.lat) {
              pointInfo = {
                lng: position.lng,
                lat: position.lat,
                address: this.form.address || ''
              };
              hasValidPoint = true;
              console.log('从 centerPoint 获取点位数据:', pointInfo);
            } else {
              console.log('这是默认坐标，不返回');
            }
          }
        } catch (error) {
          console.error('获取点位数据失败:', error);
        }
      }
      
      // 如果 centerPoint 无效但 mk 存在，从 mk 获取位置
      if (!hasValidPoint && this.mk) {
        try {
          const position = this.mk.getLngLat();
          if (position) {
            const lng = position.getLng();
            const lat = position.getLat();
            if (lng && lat && lng !== 0 && lat !== 0) {
              // 检查是否是默认坐标
              if (lng !== config.point.lng || lat !== config.point.lat) {
                pointInfo = {
                  lng: lng,
                  lat: lat,
                  address: this.form.address || ''
                };
                hasValidPoint = true;
                console.log('从 marker 获取点位数据:', pointInfo);
              } else {
                console.log('这是默认坐标，不返回');
              }
            }
          }
        } catch (error) {
          console.error('从 marker 获取点位失败:', error);
        }
      }
      
      // 如果没有有效点位，返回 null
      if (!hasValidPoint) {
        console.log('没有找到有效的点位数据');
        return null;
      }
      
      // 更新缓存
      this.currentPointData = pointInfo;
      
      console.log('返回点位数据:', pointInfo);
      return pointInfo;
    },

    async searchByKeyword(data) {
      console.log(data, 12);
      this.form.address = (data.address || '') + (data.title || '');
      if (data.location && data.location.lat && data.location.lng) {
        this.addPoint(data.location.lat, data.location.lng);
      }
    },

    async getSuggestions(str, cb) {
      var keyword = str;
      if (!keyword || keyword.trim() === '') {
        cb([]);
        return;
      }
      
      try {
        const postStr = JSON.stringify({
          keyword: keyword,
          count: 20
        });
        
        const response = await fetch(`https://api.tianditu.gov.cn/geocoder?postStr=${encodeURIComponent(postStr)}&type=geocoder&tk=${TIANDITU_CONFIG.tk}`);
        const data = await response.json();
        
        const suggestions = [];
        
        if (data.status === '0' && data.result && data.result.pois) {
          const pois = data.result.pois;
          for (let i = 0; i < Math.min(pois.length, 20); i++) {
            const poi = pois[i];
            suggestions.push({
              title: poi.name,
              address: poi.address || '',
              location: { lat: poi.lat, lng: poi.lon },
            });
          }
        }
        
        cb(suggestions);
      } catch (error) {
        console.error('地址搜索失败:', error);
        cb([]);
      }
    },

    addPoint(lat, lng) {
      if (!this.map) return;
      
      // 清除重置标志
      this.isReset = false;
      
      if (this.mk) {
        this.map.removeOverLay(this.mk);
        this.mk = null;
      }
      if (this.centerPoint) {
        this.centerPoint = null;
      }
      
      const newCenter = new T.LngLat(parseFloat(lng), parseFloat(lat));
      this.map.panTo(newCenter);
      
      this.mk = new T.Marker(newCenter);
      this.map.addOverLay(this.mk);
      
      this.centerPoint = {
        geometries: [{
          position: { lat: parseFloat(lat), lng: parseFloat(lng) }
        }],
        setMap: (val) => {
          if (val === null && this.mk) {
            this.map.removeOverLay(this.mk);
            this.mk = null;
          }
        }
      };
      
      // 更新缓存
      this.currentPointData = {
        lng: parseFloat(lng),
        lat: parseFloat(lat),
        address: this.form.address
      };
    },

   save() {
  let centerPoint = null;
  
  // 方案1: 从 mk 标记直接获取坐标
  if (this.mk) {
    try {
      const position = this.mk.getLngLat();
      if (position) {
        centerPoint = {
          lng: position.getLng(),
          lat: position.getLat()
        };
      }
    } catch(e) {
      console.error('从 mk 获取坐标失败:', e);
    }
  }
  
  // 方案2: 从 centerPoint 获取
  if (!centerPoint && this.centerPoint && this.centerPoint.geometries && this.centerPoint.geometries.length > 0) {
    try {
      const pos = this.centerPoint.geometries[0].position;
      if (pos && pos.lng && pos.lat) {
        centerPoint = pos;
      }
    } catch(e) {
      console.error('从 centerPoint 获取坐标失败:', e);
    }
  }
  
  // 方案3: 从缓存获取
  if (!centerPoint && this.currentPointData) {
    centerPoint = {
      lng: this.currentPointData.lng,
      lat: this.currentPointData.lat
    };
  }
  
  console.log('保存的坐标:', centerPoint);
  this.$emit("saveTxMapPoint", centerPoint, this.form.address, this.type);
},
    deletePoint() {
      if (this.mk) {
        this.map.removeOverLay(this.mk);
        this.mk = null;
      }
      if (this.centerPoint) {
        this.centerPoint = null;
      }
      // 删除点时清空地址输入框和缓存
      this.form.address = '';
      this.currentPointData = null;
      // 确保重置标志
      this.isReset = true;
      setTimeout(() => {
        this.isReset = false;
      }, 200);
    },
    
    /**
     * 地理编码接口（根据地址获取经纬度）
     */
    async geocodeByAddress(address) {
      if (!address || address.trim() === '') {
        return null
      }

      try {
        const ds = JSON.stringify({ keyWord: address })
        const url = `https://api.tianditu.gov.cn/geocoder?ds=${encodeURIComponent(ds)}&tk=${TIANDITU_CONFIG.tk}`
        
        console.log('地理编码请求URL:', url)
        const response = await fetch(url)
        const data = await response.json()
        
        console.log('地理编码响应:', data)
        
        if (data.status === '0' && data.location) {
          const { lon, lat, level, score } = data.location
          console.log(`地理编码成功: 经度=${lon}, 纬度=${lat}, 精度级别=${level}, 匹配度=${score}`)
          
          return {
            lng: parseFloat(lon),
            lat: parseFloat(lat),
            level: level,
            score: score,
            fullAddress: address
          }
        } else {
          console.error('地理编码失败:', data)
          this.$message.warning(`未找到地址"${address}"的坐标信息`)
          return null
        }
      } catch (error) {
        console.error('地理编码请求失败:', error)
        this.$message.error('地址解析网络请求失败')
        return null
      }
    },

    /**
     * 搜索框失去焦点事件处理
     */
    async handleBlur() {
      // 防止重复调用
      if (this.isBlurHandling) {
        return
      }
      
      const searchAddress = this.form.address
      if (!searchAddress || searchAddress.trim() === '') {
        return
      }
      
      this.isBlurHandling = true
      
      try {
        // 调用地理编码接口获取经纬度
        const locationInfo = await this.geocodeByAddress(searchAddress)
        
        if (locationInfo && locationInfo.lng && locationInfo.lat) {
          // 获取到经纬度后，在地图上标点
          this.addMarkerAndPanTo(locationInfo.lng, locationInfo.lat, searchAddress)
          this.$message.success(`已定位到：${searchAddress}`)
        } else {
          console.log('未获取到有效坐标')
          this.$message.warning('无法获取该地址的坐标信息')
        }
      } catch (error) {
        console.error('失去焦点处理异常:', error)
      } finally {
        this.isBlurHandling = false
      }
    },
    
    /**
     * 添加标记并移动到指定位置
     */
    addMarkerAndPanTo(lng, lat, address) {
      if (!this.map) {
        console.error('地图未初始化')
        return
      }
      
      // 移除现有标记
      if (this.mk) {
        this.map.removeOverLay(this.mk)
      }
      
      const point = new T.LngLat(lng, lat)
      this.mk = new T.Marker(point)
      this.map.addOverLay(this.mk)
      
      // 移动地图中心到该点
      this.map.panTo(point)
      
      // 保存坐标信息
      this.pointArr = []
      this.pointArr[0] = { point: { lng: lng, lat: lat } }
      
      // 保存地址信息
      this.address = address
      this.form.addrPoint = { lng: lng, lat: lat }
    },
  },
};
</script>

<style scoped>
#container {
  width: 100%;
  height: 64vh;
  position: relative;
}

#map {
  width: 100%;
  height: 100%;
  position: absolute;
  margin-top: 10px;
}

#toolControl {
  position: relative;
  top: 20px;
  left: 10px;
  margin: auto;
  z-index: 1001;
}

.toolItem {
  width: 40px;
  height: 40px;
  float: left;
  margin: 1px;
  padding: 4px;
  border-radius: 3px;
  background-size: 30px 30px;
  background-position: 4px 4px;
  background-repeat: no-repeat;
  box-shadow: 0 1px 2px 0 #e4e7ef;
  background-color: #ffffff;
  border: 1px solid #ffffff;
}

.toolItem:hover {
  border-color: #789cff;
}

.active {
  border-color: #d5dff2;
  background-color: #d5dff2;
}

.tipsHelp {
  margin-left: 10px;
  color: white;
  font-size: 16px;
  line-height: 30px;
}
.input{
  width: 600px;
}
</style>